import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { Action } from '~/domains/actions/types'

export const taskQueryKey = (taskId: number) => ['task', taskId]

export const useTask = (taskId: number | null) =>
  useQuery({
    queryKey: taskQueryKey(taskId ?? 0),
    queryFn: () =>
      fetchApiWithToken<Action>({
        method: 'get',
        url: `/v1/actions/${taskId}`
      }),
    enabled: taskId !== null,
    // Always read from the server when the aside opens: lists may be outdated
    gcTime: 0
  })
